export enum Role {
  CLIENT = "CLIENT",
  THERAPIST = "THERAPIST",
  SUPER_ADMIN = "SUPER_ADMIN",
  SUB_ADMIN = "SUB_ADMIN",
}